export const NOTE_MAX_LENGTH = 2000;
